import * as types from "../action/ActionType";
import { INNER_NOTIFICATION_INITIAL} from "../store/InitialStore";
export default function AllNotificationDetailsReducer(state = INNER_NOTIFICATION_INITIAL, action) {
  const { type, payload } = action;
  console.log(payload,'pairukjkjka')
  switch (type) {
    case types.INNER_NOTIFICATION_DETAILS_REUX:
      return (state = payload);
    default:
      return state;
  }
}
